import { useNavigate } from 'react-router-dom';

import { useCard } from '../../../hook/useCard';
import { useSet } from '../../../hook/useSet';
import WorkspacePanel, { WorkspacePanelHead } from '../../../components/WorkspacePanel/WorkspacePanel';
import CardsList from '../../../components/CardList/CardList';
import { buildRoute } from '../AllCardsPage.Route';

const CardListPanel = () => {
	const navigate = useNavigate();

	const { activeSet } = useSet();
	const { cards, activeCard } = useCard();

	const handleSelectCard = (card) => {
		let cardUrl = buildRoute(activeSet, card);
		navigate(cardUrl);
	};

	return (
		<WorkspacePanel className="card-list-panel">
			<WorkspacePanelHead title={`${activeSet ? activeSet.name : ''}`} />
			<CardsList activeCard={activeCard} cards={cards} onSelectCard={handleSelectCard} />
		</WorkspacePanel>
	);
};

CardListPanel.propTypes = {};

export default CardListPanel;
